'use client';
import {useRouter} from "next/navigation";
import {useEffect} from "react";

export default function Home() {
  const router = useRouter();

  useEffect(() => {
    void router.push("/form");
  }, [router])

  return (<div></div>);
}
